export const RESEND_TIMER_SECONDS_IN_MINUTE = 60

export const RESEND_TIMER_DEFAULT_SECONDS = RESEND_TIMER_SECONDS_IN_MINUTE
